export enum BranchAnalyticsEnum {
  VIEW_BRANCHES_PAGE = '[PAC WEB] Unidades Físicas - Página visualizada',
  BRANCH_PROFILE_CLICK_WHATSAPP_SCHEDULE = '[PAC WEB] Perfil da Unidade - Clicou em "Quero agendar" (WhatsApp)',
}
